import Snackbar from "@material-ui/core/Snackbar";
import { Component } from "react";
import { connect } from "react-redux";

import { mapActionsToProps } from "./../redux/app";
import SnackbarContentWrapper from "./SnackbarContentWrapper";

class MySnackbar extends Component {
  handleClose() {
    this.props.closeSnackbar && this.props.closeSnackbar();
  }
  render() {
    const { snackbar } = this.props;
    return (
      <Snackbar
        open={snackbar.open}
        anchorOrigin={snackbar.anchorOrigin}
        onClose={this.handleClose.bind(this)}
        autoHideDuration={2000}>
        <SnackbarContentWrapper
          onClose={this.handleClose.bind(this)}
          variant={snackbar.variant}
          message={snackbar.message}
        />
      </Snackbar>
    );
  }
}

const mapStateToProps = (state) => ({
  snackbar: state.app.snackbar,
});

export default connect(mapStateToProps, mapActionsToProps)(MySnackbar);
